/**
 * Component Registry for Dietz Property Group Theme
 *
 * Extends the base landing-page theme registry with Dietz Property Group specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-landing-page/registry';
import { FloorplansList } from './components';

/**
 * Dietz Property Group specific component overrides.
 * These components have been customized for the Dietz Property Group brand.
 */
const dietzpropertygroupOverrides: Partial<ComponentRegistry> = {
  // Replace the parent FloorplansList with a thin wrapper that renders
  // only the `apartment-sync` block.
  FloorplansList,
};

/**
 * Final merged registry for Dietz Property Group properties.
 * Inherits all components from the landing-page theme, with Dietz Property Group overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...dietzpropertygroupOverrides,
};

export default registry;
